import { theme } from "@huub-web/ui/theme/css/theme.css";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

export const interestRatesSimpleImageStyle = style({
  width: rem(60),
  height: rem(40),
  objectFit: "contain",
  filter: "grayscale(100%)",
  marginLeft: theme.spacings.xs,
});

/**
 * Container query context for the rate rows.
 * Makes the responsive CTA behavior self-contained
 * instead of relying on a parent Card ancestor.
 */
export const rateRowListStyle = style({
  containerType: "inline-size",
  containerName: "rate-list",
});

/**
 * Flex sizing for the name + rate group.
 * Wraps below the logo when less than 20rem is available.
 */
export const rateRowContentStyle = style({
  flex: `1 1 ${rem(320)}`,
  minWidth: 0,
});

/**
 * CTA button wrapper.
 * Wide: intrinsic width, text centered.
 * Narrow (rate-list < 500px): full-width row, button stretches.
 */
export const rateRowCtaStyle = style({
  display: "grid",
  textAlign: "center",
  "@container": {
    "rate-list (max-width: 650px)": {
      marginInline: "auto",
    },
    "rate-list (max-width: 500px)": {
      flex: "1 0 100%",
    },
  },
});
